<template>
  <div class="home">
    <Hero :lead="lead" />
    <Features />
    <Pitch />
    <!-- <Testimonial /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Features from "@/components/Features";
import Hero from "@/components/Hero";
import Pitch from "@/components/Pitch";
// import Testimonial from "@/components/Testimonial";

export default {
  name: "home",
  metaInfo: {
    title: "Home",
    titleTemplate: "%s | Experience Web Development"
  },
  components: {
    Hero,
    Features,
    Pitch
    // Testimonial
  },
  data() {
    return {
      lead: "COMPLETE WEB & APP DEVELOPMENT SOLUTIONS."
    };
  }
};
</script>
